export default __webpack_public_path__ + "928e12b52e3f0cdff50eacd31bb20a8a.png";